import { Website } from "../../../reducers/builderReducers/website/websiteApi";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: Website = {
  id: 0,
  name: "",
  baseFontSize: "",
  rowColor: "",
  elementColor: "",
  description: "",
  columnColor: "",
  shopBRadius: "0px",
  contentWidthUnit: "",
  contentWidthSize: 0,
  status: "",
  tracking: "",
  type: "",
  useBrowserLanguage: 0,
  parentCustomFileId: 0,
  favicon: undefined,
  defaultTypographyId: 0,
};

export const websiteSlice = createSlice({
  name: "website",
  initialState,
  reducers: {
    UPDATE_WEBSITE: (state, action: PayloadAction<Website>) => {
      state = action.payload;
      var r = document.querySelector(":root") as any;

      r.style.setProperty("--builder-row-color", state.rowColor);
      r.style.setProperty("--builder-col-color", state.columnColor);
      r.style.setProperty("--builder-element-color", state.elementColor);
      return state;
    },
  },
});

// Action creators are generated for each reducer function
export const { UPDATE_WEBSITE } = websiteSlice.actions;

export default websiteSlice.reducer;
